// extracted by mini-css-extract-plugin
export default {"container":"NavMenu-module__container--d7a3","menus":"NavMenu-module__menus--e69b","item":"NavMenu-module__item--a950","active":"NavMenu-module__active--ca03"};